import {
  GridIcon,
  InsightsIcon,
  IterationIcon,
  SlidersIcon,
  TimelineIcon,
  TrackerIcon,
  WeekIcon,
} from './icons'
import { navigate, type Route } from '../lib/router'
import { useOnline } from '../lib/online'

const ITEMS: Array<{ route: Route; label: string; Icon: typeof GridIcon }> = [
  { route: 'now', label: 'Now', Icon: GridIcon },
  { route: 'today', label: 'Today', Icon: TimelineIcon },
  { route: 'week', label: 'Week', Icon: WeekIcon },
  { route: 'track', label: 'Trackers', Icon: TrackerIcon },
  { route: 'iterations', label: 'Iterations', Icon: IterationIcon },
  { route: 'insights', label: 'Insights', Icon: InsightsIcon },
]

/** Desktop navigation. On a phone this is replaced by the bottom tab bar. */
export function Sidebar({ current }: { current: Route }) {
  const online = useOnline()
  return (
    <nav
      aria-label="Sections"
      className="flex w-[208px] shrink-0 flex-col border-r border-line bg-surface px-3 py-4"
    >
      <div className="flex items-center gap-2.5 px-2 pb-5">
        <img src="/favicon.svg" alt="" width={22} height={22} className="rounded" />
        <span className="text-[16px] font-semibold tracking-tight">TimeGrid</span>
      </div>

      <ul className="flex flex-col gap-0.5">
        {ITEMS.map(({ route, label, Icon }) => {
          const active = current === route
          return (
            <li key={route}>
              <button
                type="button"
                onClick={() => navigate(route)}
                aria-current={active ? 'page' : undefined}
                className={`flex w-full items-center gap-2.5 rounded-lg px-3 py-2.5 text-[15px] font-medium transition-colors duration-150 ease-[var(--ease-out-quick)] ${
                  active ? 'bg-raised text-text' : 'text-dim hover:bg-raised/60 hover:text-text'
                }`}
              >
                <Icon width={19} height={19} />
                {label}
              </button>
            </li>
          )
        })}
      </ul>

      <div className="mt-auto flex flex-col gap-2">
        {!online ? (
          <span className="mx-2 rounded-md border border-line-strong px-2 py-1 text-center text-[11px] font-medium tracking-wide text-dim uppercase">
            Offline
          </span>
        ) : null}
        <button
          type="button"
          onClick={() => navigate('settings')}
          aria-current={current === 'settings' ? 'page' : undefined}
          className={`flex w-full items-center gap-2.5 rounded-lg px-3 py-2.5 text-[15px] font-medium transition-colors duration-150 ${
            current === 'settings' ? 'bg-raised text-text' : 'text-dim hover:bg-raised/60 hover:text-text'
          }`}
        >
          <SlidersIcon width={19} height={19} />
          Settings
        </button>
      </div>
    </nav>
  )
}
